import React, {Component} from 'react'

import MyNavBar from './navbar.js';
import MyMap from './map.js';

class App extends Component {
    render() {
        return (
            <div>
                <MyNavBar />
                <MyMap />
            </div>
        )
    }
}

export default App;
